import { CommonModule } from '@angular/common';
import { Component, HostListener, ViewChild } from '@angular/core';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { LayoutModule } from '../../layout.module';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  standalone: true,
  imports: [CommonModule, LayoutModule, RouterModule, MatSidenavModule],
})
export class LayoutComponent {
  innerWidth: number = window.innerWidth;
  isOpened = false;
  isFullScreen = false;

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.innerWidth = window.innerWidth;
  }

  @ViewChild('drawer') drawer!: MatDrawer;

  showMenuText:boolean =true;

  setShowMenuText(value:boolean){
    this.showMenuText = value;
  }
}
